function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { captchaApi, getCmsKeyApi, getCmsApi, registerUserApi, savePasswordApi, site as _site, getPerfectList, userScanKeyApi, loginInfo } from '@/api/user';
import notice from '@/libs/notice';
import sendVerifyCode from '@/mixins/SendVerifyCode';
import helper from '@/libs/helper';
import QRCode from 'qrcodejs2';
import { roterPre } from '@/settings';
import { getMenus } from '@/utils/auth';
export default {
  name: 'Login',
  mixins: [sendVerifyCode],
  data: function data() {
    var _this2 = this;
    var validateUsername = function validateUsername(rule, value, callback) {
      if (!value) {
        callback(new Error(_this2.$t('login.phone')));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (!value) {
        callback(new Error(_this2.$t('login.title2')));
      } else {
        callback();
      }
    };
    var checkPhone = function checkPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error(_this2.$t('customer.placeholder09')));
      }
      setTimeout(function () {
        if (helper.phoneReg.test(value)) {
          callback();
        } else {
          callback(new Error(_this2.$t('customer.placeholder71')));
        }
      }, 150);
    };
    return {
      sitedata: '',
      fullWidth: document.body.clientWidth,
      swiperOption: {
        pagination: {
          el: '.pagination'
        },
        autoplay: {
          enabled: true,
          disableOnInteraction: false,
          delay: 3000
        }
      },
      loginLogo: '',
      swiperList: [],
      captchatImg: '',
      loginForm: {
        account: '',
        password: '',
        key: '',
        captcha: '',
        verification_code: '',
        phone: ''
      },
      loginRules: {
        account: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }],
        captcha: [{
          required: true,
          message: this.$t('login.title5'),
          trigger: 'blur'
        }],
        verification_code: [{
          required: true,
          message: this.$t('login.title6'),
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          validator: checkPhone,
          trigger: 'change'
        }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      activeName: 'passwordLogin',
      loginType: 1,
      // 1登录 2注册 3忘记密码
      cmsKey: '',
      // 短信验证码的key,
      topKeys: {},
      // 顶部导航菜单
      qrcode: null,
      codeLoading: false,
      codeTimer: null,
      codeKey: '',
      codeButton: false,
      codeSuccess: false,
      codeShowLogin: false
    };
  },
  watch: {
    fullWidth: function fullWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        var that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          that.timer = false;
        }, 400);
      }
    },
    $route: {
      handler: function handler(route) {
        var query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {
    if (this.$route.query.loginType) {
      this.loginType = this.$route.query.loginType;
    }
    var _this = this;
    document.onkeydown = function (e) {
      if (_this.$route.path.indexOf('login') !== -1) {
        var key = window.event.keyCode;
        if (key === 13) {
          _this.handleLogin();
        }
      }
    };
    window.addEventListener('resize', this.handleResize);
    // this.getCmsKey()
  },
  mounted: function mounted() {
    this.site();
    this.getCaptcha();
  },
  beforeCreate: function beforeCreate() {},
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.codeTimer);
    this.codeTimer = null;
  },
  destroyed: function destroyed() {},
  methods: {
    // 站点配置
    site: function site() {
      var _this3 = this;
      _site().then(function (res) {
        _this3.sitedata = res.data;
        localStorage.setItem('sitedata', JSON.stringify(_this3.sitedata));
      });
    },
    resetForm: function resetForm() {
      this.loginForm = {
        account: '',
        password: '',
        key: '',
        captcha: '',
        verification_code: '',
        phone: ''
      };
    },
    tabChange: function tabChange() {
      if (this.activeName == 'passwordLogin') {
        this.loginForm.account = this.loginForm.phone;
      } else if (this.activeName == 'cmsLogin') {
        this.loginForm.phone = this.loginForm.account;
      }
    },
    // 获取短信验证码的key
    getCmsKey: function getCmsKey() {
      var _this4 = this;
      getCmsKeyApi().then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          var exp;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this4.cmsKey = res.data;
                exp = helper.phoneReg;
                if (_this4.loginForm.phone) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", _this4.$message.error(_this4.$t('login.title1')));
              case 4:
                if (exp.test(_this4.loginForm.phone)) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return", _this4.$message.error(_this4.$t('login.title9')));
              case 6:
                _context.next = 8;
                return getCmsApi({
                  phone: _this4.loginForm.phone,
                  key: _this4.cmsKey.key,
                  types: 0,
                  from: 1
                }).then(function (res) {
                  if (res.status == 200) {
                    _this4.sendCode();
                  }
                });
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 切换
    handelTabTagger: function handelTabTagger(type) {
      this.loginType = type;
      this.resetForm();
    },
    // 发送手机验证码
    code: function code() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this5.getCmsKey();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 忘记密码
    handleResetPwd: function handleResetPwd() {
      var _this6 = this;
      this.$refs['loginForm'].validate(function (valid) {
        if (valid) {
          _this6.loading = true;
          _this6.loginForm.password_confirm = _this6.loginForm.password;
          savePasswordApi(_this6.loginForm).then(function (res) {
            _this6.loading = false;
            _this6.loginType = 1;
            _this6.resetForm();
          }).catch(function (error) {
            _this6.loading = false;
          });
        }
      });
    },
    imageCode: function imageCode() {
      if (this.codeShowLogin) {
        this.codeShowLogin = false;
        if (this.codeTimer) {
          clearInterval(this.codeTimer);
        }
      } else {
        this.codeShowLogin = true;
        this.getUserKey();
      }
    },
    getCaptcha: function getCaptcha() {
      var _this7 = this;
      captchaApi().then(function (_ref2) {
        var data = _ref2.data;
        _this7.captchatImg = data.img;
        _this7.loginForm.key = data.key;
      });
    },
    checkCapslock: function checkCapslock(e) {
      var key = e.key;
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z';
    },
    showPwd: function showPwd() {
      var _this8 = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this8.$refs.password.focus();
      });
    },
    // 用户注册
    handleRegister: function handleRegister() {
      var _this9 = this;
      this.$refs['loginForm'].validate(function (valid) {
        if (valid) {
          _this9.loading = true;
          _this9.loginForm.password_confirm = _this9.loginForm.password;
          registerUserApi(_this9.loginForm).then(function (res) {
            _this9.loading = false;
            _this9.loginType = 1;
            _this9.resetForm();
          }).catch(function (error) {
            _this9.loading = false;
          });
        }
      });
    },
    handleLogin: function handleLogin() {
      var _this10 = this;
      this.$refs['loginForm'].validate(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(valid) {
          var payload;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (valid) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return", false);
              case 2:
                _this10.loading = true;
                payload = {
                  userInfo: _this10.loginForm,
                  activeName: _this10.activeName
                };
                _context3.next = 6;
                return _this10.$store.dispatch('user/login', payload).catch(function () {
                  _this10.loading = false;
                  _this10.loginForm.captcha = '';
                  _this10.getCaptcha();
                });
              case 6:
                _this10.loading = false;
                _context3.next = 9;
                return _this10.getInfo();
              case 9:
                _context3.next = 11;
                return _this10.loginAfter();
              case 11:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    handleResize: function handleResize(event) {
      this.fullWidth = document.body.clientWidth;
    },
    // 获取生成二维码
    getUserKey: function getUserKey() {
      var _this11 = this;
      this.codeLoading = true;
      this.codeSuccess = false;
      userScanKeyApi().then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(res) {
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this11.$nextTick();
              case 2:
                _this11.$refs.QRCode_header.innerHTML = '';
                _this11.codeKey = res.data.key;
                _this11.qrcode = new QRCode(_this11.$refs.QRCode_header, {
                  text: _this11.codeKey,
                  width: 190,
                  height: 190,
                  colorDark: '#000000',
                  colorLight: '#ffffff',
                  correctLevel: QRCode.CorrectLevel.M
                });
                _this11.qrcode._el.title = '';
                _this11.codeButton = false;
                _this11.codeTimer = setInterval(function () {
                  _this11.getUserStatus();
                }, 2000);
                _this11.codeLoading = false;
              case 9:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this11.codeLoading = false;
      });
    },
    // 获取登录返回状态
    getUserStatus: function getUserStatus() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this12.$store.dispatch('user/scanLogin', {
                key: _this12.codeKey
              }).then(function (data) {
                if (data.status === -1) {
                  _this12.codeButton = true;
                  _this12.codeSuccess = false;
                  if (_this12.codeTimer) {
                    clearInterval(_this12.codeTimer);
                  }
                } else if (data.status === 1) {
                  _this12.codeSuccess = true;
                }
              }).catch(function (err) {
                if (_this12.codeTimer) {
                  clearInterval(_this12.codeTimer);
                }
                _this12.$message.error(err.message);
              });
            case 2:
              _context5.next = 4;
              return _this12.loginAfter();
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getInfo: function getInfo() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return loginInfo();
            case 2:
              res = _context6.sent;
              _this13.$store.commit('user/SET_USERINFO', res.data.userInfo);
              _this13.$store.commit('user/SET_ENTINFO', res.data.enterprise);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    loginAfter: function loginAfter() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var path, uid;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!_this14.$store.getters.isLogin) {
                _context7.next = 13;
                break;
              }
              path = _this14.$route.query.redirect;
              _this14.$store.commit('app/SET_PARENTCUR', 0);
              _context7.next = 5;
              return getMenus();
            case 5:
              uid = path.split('=')[1];
              localStorage.setItem('uni', uid);

              // 获取邀请完善记录
              if (uid) {
                getPerfectList(uid).then(function () {
                  localStorage.removeItem('uni');
                }).catch(function () {
                  localStorage.removeItem('uni');
                });
              }
              if (uid) {
                _this14.$router.push({
                  name: 'resume',
                  path: '/'
                });
              }
              _this14.$router.push({
                path: "".concat(roterPre, "/user/workbench/index"),
                query: _this14.otherQuery
              });
              _this14.loading = false;
              _this14.$root.closeNotice();
              _this14.$root.notice = notice(_this14.$store.getters.token);
            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    }
  }
};